import {
  base_colorAction,
  cta_linkTextAlert,
  cta_linkTextAlertHover,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { font_family_weight_medium, font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  cursor: pointer;

  color: ${text_colorTextSecondary};
  font-family: ${font_family_weight_medium};
  ${font_md}

  /* VARIANTS */
  &:hover,
  &.active {
    color: ${base_colorAction};
  }

  &.severe {
    color: ${cta_linkTextAlert};
    &:hover {
      color: ${cta_linkTextAlertHover};
    }
  }
`
